export default class Route {
	constructor (path, component = null) {
		if (!path) {
			return new Error('[Route] missing path argument')
		}
		this._path = path
		this._component = component
		this._redirect = false
		this._name = null
		this._middlewares = []
		this._permissions = []
		this._children = []
		this._meta = {}
		this._props = null
	}

	middlewares (middlewares) {
		this._middlewares = this._middlewares.concat(middlewares)
		return this
	}

	permissions (permissions) {
		this._permissions = permissions
		return this
	}

	children (children) {
		this._children = this._children.concat(children)
		return this
	}

	as (name) {
		this._name = name
		return this
	}

	props (props) {
		this._props = props

		return this
	}

	meta (metaObject) {
		this._meta = metaObject
		return this
	}

	redirect (to) {
		this._redirect = to
		return this
	}

	_compile () {
		const route = {
			path: this._path,
			meta: this._meta
		}

		if (this._redirect) {
			route['redirect'] = this._redirect
			if (typeof this._redirect === 'function') {
				return route
			}
		}

		if (this._props) {
			route['props'] = (route) => this._props.reduce((result, prop) => (
				result = { ...result, [prop]: route.query[prop] }
			), {})
		}

		if (this._name) {
			route['name'] = this._name
		}

		if (this._component) {
			route['component'] = this._component
		}

		if (this._middlewares.length) {
			route.meta['middlewares'] = this._middlewares
		}

		if (this._permissions.length) {
			route.meta['permissions'] = this._permissions
		}

		if (this._children.length) {
			route['children'] = this._children
		}

		return route
	}
}
